export default "__VITE_ASSET__DWU$DTDk__"